import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Lawyers</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs crumbs={[{ url: '/lawyers', name: 'Lawyers' }]} />
                <h2 className="lead text-center">
                  Lawyers
                  <p style={{ fontSize: '11px' }}>21/11/2018</p>
                </h2>

                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <p>
                      There’s a range of legal procedures to be completed when you buy a house, and a few of these have
                      to be done by a lawyer. Your lawyer will check contracts, make sure the property’s title is in
                      order, transfer the property to your name (conveyancing), arrange valuations and reports, and
                      register your mortgage on the property title (officially making you the owner). These are things
                      that you definitely have to get right as by submitting an offer you are entering into a formal
                      agreement that you can be held accountable for.
                    </p>
                    <p>
                      You can definitely do some of these if you are confident in your abilities, but at some point you
                      will have to involve a lawyer to do the conveyancing and registering the mortgage. Lawyer’s fees
                      vary, so ask around and get an estimate. You can expect to pay around $1500 in legal fees, plus
                      $200-$300 in costs for things like land transfer fees. This may seem like a lot but it ends up
                      being only a small fraction of the amount you will spend on buying a home, and going without one
                      could ultimately result in much greater costs - both financially and figuratively.
                    </p>
                    <p>
                      We found that lots of lawyers had special deals for first home buyers where they only charging
                      when a successful purchase had been made. This removes the risk of having to pay lawyers fees for
                      unsuccessful offers, of which there can be a lot (we had 6). You might find that the bank you have
                      your mortgage through offers a certain amount of money towards settlement costs (in our case they
                      gave us $2500)
                    </p>
                    <p>
                      Your friends or family might be able to recommend a lawyer who specialises in property or
                      conveyancing, or you can find one online. We were recommended ours by our mortgage broker and we
                      couldn't have been happier.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Lawyers.jsx